<div class="dialogOverlay" (click)="onClose()" (keydown)="onClose()">
  <div class="dialogContainer" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
    <div class="dialogHeader">
      <h2 class="dialogTitle">{{ dialogTitle }}</h2>
      <button class="closeBtn" (click)="onClose()" aria-label="Close dialog">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
    </div>

    <div class="metadataCont" *ngIf="hasMetadata()">
      <div class="metadataItem" *ngFor="let key of getMetadataKeys()">
        <span class="metadataLabel">{{ key }}</span>
        <span class="metadataValue">{{ metadata[key] }}</span>
      </div>
    </div>
    <ng-container *ngFor="let step of stepDetails; let i = index" class="dialogContent">
      <div class="dialogContent" *ngIf="currentStepselected === i">
        <div class="instruction-section">
          <p class="instruction">{{ stepDetails[i].stepHeader }}</p>
          <hr class="vertical" *ngIf="hasSelections()">
          <a (click)="clearAllSelections()" class="dmintLinkBtn red" *ngIf="hasSelections()">
            Clear all
          </a>
        </div>
        <!-- Validation Error Message -->
        <div class="validationError" *ngIf="validateDependentSelections()==false && validationError">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z"
              fill="#DC2626" />
          </svg>
          <span>{{ validationError }}</span>
        </div>

        <div class="productLinesList">
            <div class="productLineRow" *ngFor="let selectionGroup of selectionGroups" 
               [style.grid-template-columns]="selectionGroup.code ? '' : '1fr 80px'">

            <div class="productLineLabel" *ngIf="selectionGroup.code">{{ selectionGroup.code }}</div>
            <div class="optionsContainer">
              <button *ngFor="let option of selectionGroup.options" class="optionChip"
                [class.selected]="isOptionSelected(selectionGroup, option)"
                (click)="toggleOption(selectionGroup, option)">
                {{ option }}
                <span *ngIf="isOptionSelected(selectionGroup, option)" class="removeIcon">×</span>
              </button>
            </div>
            <div *ngIf="step.stepActionSelectAll" class="selectActions">
              <a class="dmintLinkBtn" *ngIf="!areAllOptionsSelected(selectionGroup)"
                (click)="selectAllGroups(selectionGroup)">
                Select all
              </a>
              <a class="dmintLinkBtn red" *ngIf="areAllOptionsSelected(selectionGroup)"
                (click)="unselectAllGroups(selectionGroup)">
                Unselect all
              </a>
            </div>
            <img *ngIf="step.stepActionDelete" style="cursor: pointer;" src="assets/images/Trash.svg"
              (click)="deleteSelectionGroup(selectionGroup)">

          </div>
        </div>
      </div>
      <div class="dialogActions" *ngIf="currentStepselected === i">
        <button *ngIf="currentStepselected > 0" class="secondary backBtn"
          (click)="onBack(step.stepNumber)">
          Back
        </button>
        <button *ngIf="currentStepselected < stepDetails.length - 1" class="primary nextBtn"
          (click)="onNext(step.stepNumber,i)" [disabled]="!hasSelections()">
          Next
        </button>
        <button *ngIf="currentStepselected === stepDetails.length - 1"
          class="primary submitBtn" (click)="onSubmit()" [disabled]="!hasSelections()">
          Submit
        </button>
      </div>
    </ng-container>
  </div>
</div>